/* eslint-disable max-len */
import { PropTypes } from 'prop-types'
import React from 'react'
import styles from './styles'

const SvodExclusiveWarning = props => (
  <div className="SvodExclusiveWarning">
    <div className="logo-wrapper">
      {// eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a className="exclusive-logo">
          Player Plus Exclusive
        </a>
      }
    </div>
    {props.includeText && (
      <span className="svod-exclusive-text">Exclusive</span>
    )}
    <style jsx>{styles}</style>
  </div>
)

SvodExclusiveWarning.propTypes = {
  includeText: PropTypes.bool,
}

SvodExclusiveWarning.defaultProps = {
  includeText: false,
}

export default SvodExclusiveWarning
